import React from 'react';

export default function WalletDetailCard({ wallet }) {
  return (
    <div className={'p-5 shadow bg-white w-full'}>
      <div>
        <div>
          <h3 className={'text-yellow-500 font-light'}>Available Balance</h3>
          <h3 className={'text-xl lg:text-3xl text-gray-500 font-semibold'}>
            {wallet && wallet.currency_code} {wallet && wallet.account_balance}
          </h3>
        </div>
        <div className={'mt-3'}>
          <h3 className={'text-yellow-500 font-light'}>Wallet ID</h3>
          <h3 className={'text-lg text-gray-500 font-semibold'}>
            {wallet && wallet.wallet_no}
          </h3>
        </div>
      </div>
    </div>
  );
}
